import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const CreateProjectWrapper = styled.div`
  .view-invoice-btn {
    flex-grow: 1;
    text-align: right;
    ${responsive.MOBILE`
        width: 100%;
        margin-bottom: 16px;

        button {
          width: 100%;
        }
    `}
  }
`;

export const CreateProjectInformationWrapper = styled.div`
  .confirm-message {
    color: ${COLORS.cirrus_black10};
    line-height: 22px;
  }
`;
